import { render, staticRenderFns } from "./TipoJornada.vue?vue&type=template&id=b3fa40de&scoped=true"
import script from "./TipoJornada.vue?vue&type=script&lang=js"
export * from "./TipoJornada.vue?vue&type=script&lang=js"
import style0 from "./TipoJornada.vue?vue&type=style&index=0&id=b3fa40de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fa40de",
  null
  
)

export default component.exports